module.exports = __webpack_public_path__ + "static/media/Dancewithme.bd714620.png";